module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-waermeerzeugung-634d8ccf762c0cfc08c19f5b95347111.svg";